import {
    DXP_ADD_PODCAST,
    DXP_ADD_PODCAST_ERROR,
    DXP_GET_PODCASTS_PAGE,
    DXP_GET_PODCASTS_PAGE_ERROR,
    DXP_SEARCH_PODCASTS_PAGE,
    DXP_SEARCH_PODCASTS_PAGE_ERROR,
    DXP_SELECT_PODCAST,
    DXP_GET_PODCAST_COUNT,
    DXP_GET_PODCAST_COUNT_ERROR,
    DXP_SEARCH_PODCAST_COUNT,
    DXP_SEARCH_PODCAST_COUNT_ERROR,
    DXP_UPDATE_PODCAST,
    DXP_UPDATE_PODCAST_ERROR,
    DXP_DELETE_PODCAST,
    DXP_DELETE_PODCAST_ERROR,
} from "../actions/types";

const initialState = {
    count: 0,
    searchCount: 0,
    podcasts: [],
    searchPodcasts: [],
    selectedPodcast: null,
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case DXP_GET_PODCASTS_PAGE:
            return {
                ...state,
                podcasts: payload,
                isLoading: false,
                success: true,
            };

        case DXP_SEARCH_PODCASTS_PAGE:
            return {
                ...state,
                searchPodcasts: payload,
                isLoading: false,
                success: true,
            };

        case DXP_GET_PODCAST_COUNT:
            return {
                ...state,
                count: payload,
                isLoading: false,
                success: true
            }

        case DXP_SEARCH_PODCAST_COUNT:
            return {
                ...state,
                searchCount: payload,
                isLoading: false,
                success: true
            }

        case DXP_SELECT_PODCAST:
            return {
                ...state,
                selectedPodcast: payload,
            };

        case DXP_ADD_PODCAST:
        case DXP_UPDATE_PODCAST:
        case DXP_DELETE_PODCAST:
            return {
                ...state,
                isLoading: false,
                success: true,
            };

        case DXP_GET_PODCASTS_PAGE_ERROR:
            return {
                ...state,
                podcasts: [],
                isLoading: false,
                success: false,
            };

        case DXP_SEARCH_PODCASTS_PAGE_ERROR:
            return {
                ...state,
                searchPodcasts: [],
                isLoading: false,
                success: false,
            };

        case DXP_GET_PODCAST_COUNT_ERROR:
            return {
                ...state,
                count: 0,
                isLoading: false,
                success: false
            }

        case DXP_SEARCH_PODCAST_COUNT_ERROR:
            return {
                ...state,
                searchCount: 0,
                isLoading: false,
                success: false
            }
        case DXP_ADD_PODCAST_ERROR:
        case DXP_UPDATE_PODCAST_ERROR:
        case DXP_DELETE_PODCAST_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}
